export default {
	init($) {

		function splitText() {
			const $detailsList = $('.subscription-details')
			
			$detailsList.each(function () {
				const $details = $(this)
				const lines = $details.text().trim().split('\n')
				const processedLines = lines.map(line => {
					const parts = line.split('with')
					if (parts.length === 2) {
						return `${parts[0]}<span class="subscription-details__small">with ${parts[1].trim()}</span>`
					}
					return line
				})
				$details.html(processedLines.join('<br>'))
			})
		}

		$(document).on('updated_checkout', function () {
			splitText()
		})

	}
}